import { styled } from "@mui/material/styles";

export const Footer = styled("div")(() => ({
  padding: "16px 24px",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  gap: 16,
}));

export const UITabWrapper = styled("div")(() => ({
  padding: "24px 32px",
}));
